module.exports = __webpack_public_path__ + "static/media/5.cc1f3f97.jpg";